<div class="main-component-container">
    <h1>{{ 'disabled-user.title' | trackAndTranslate }}</h1>

    <p>{{ 'disabled-user.content' | trackAndTranslate }}<a href="mailto:{{ 'email.address' | trackAndTranslate }}">{{ 'email.address' |
            trackAndTranslate }}</a></p>


</div>
